import { render, staticRenderFns } from "./ChangeStudentAttendance.vue?vue&type=template&id=48cc8532"
import script from "./ChangeStudentAttendance.vue?vue&type=script&lang=js"
export * from "./ChangeStudentAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports